import { ActionTypes } from "./user.actions";
import { ActionTypes as AccountActionTypes } from "../account/account.actions";
import { Action } from "@ngrx/store";
import { Settings } from "@core/store/settings/settings.model";

export interface State {
  settings: Settings;
  loading: boolean;
  subscription_active: boolean;
}

export const initialState: State = {
  settings: null,
  loading: false,
  subscription_active: true,
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case ActionTypes.LOAD:
      return Object.assign({}, state, { loading: true });

    case ActionTypes.LOAD_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        settings: action.payload.settings,
        subscription_active: action.payload.hasActiveSubscription,
      });

    case ActionTypes.LOAD_FAIL:
      return Object.assign({}, state, { loading: false });

    case ActionTypes.SAVE_SETTINGS:
      return Object.assign({}, state, { loading: true });

    case ActionTypes.SAVE_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        settings: action.payload,
      });

    case ActionTypes.SAVE_SETTINGS_FAIL:
      return Object.assign({}, state, { loading: false });

    case AccountActionTypes.LOAD_SUCCESS:
      return Object.assign({}, state, {
        subscription_active: action.payload.subscriptionActive,
      });

    default:
      return state;
  }
}

export const getSettings = (state: State) => state.settings;
export const hasSubscriptionActive = (state: State) =>
  state.subscription_active;
export const isLoading = (state: State) => state.loading;



// WEBPACK FOOTER //
// /app/src/app/core/store/user/user.reducer.ts